import {create} from 'zustand';
import {HideStepBarStore} from './types';

const useHideStepBarStore = create<HideStepBarStore>(set => ({
	hideStepBar: false,
	setHideStepBar: value => set({hideStepBar: value}),
}));

export {useHideStepBarStore};
